// extracted by mini-css-extract-plugin
export var maindiv = "experienceTile-module--maindiv--VJcpi";
export var hoverOverMe = "experienceTile-module--hoverOverMe--eAWVB";
export var imgDiv = "experienceTile-module--imgDiv--UJ5O-";
export var midImgDiv = "experienceTile-module--midImgDiv--uLHwI";
export var img = "experienceTile-module--img--AUoVu";
export var sideDiv = "experienceTile-module--sideDiv--72Sgn";
export var sideOuterDiv = "experienceTile-module--sideOuterDiv--4-+FT";
export var sideMidDiv = "experienceTile-module--sideMidDiv--zobxM";
export var name = "experienceTile-module--name--y8aUe";
export var company = "experienceTile-module--company--fe5f2";
export var year = "experienceTile-module--year--6nODr";
export var desc = "experienceTile-module--desc--lYgkz";